import React from 'react';

const TenantFormModal = React.lazy(() => import('../components/FormModal'));
const tenantModalRegistry = {
    core_tenantId: TenantFormModal
};
export default tenantModalRegistry;
